import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import vImg from "../../images/video/img03.jpg";
import vImg2 from "../../images/video/polygon02.png";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerBackup from "../../images/banners/banner_backup.png";

const BackupCloudPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Backup Cloud
                      </span>
                      <h2 className="title">
                        Proteção automatizada dos seus dados críticos com
                        recuperação instantânea
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerBackup} alt="Cloud Backup Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Backup Cloud Somar: Seus Dados Sempre Seguros
                </h2>
                <p className="sd-content">
                  O Backup Cloud da Somar oferece proteção automatizada e
                  inteligente para todos os dados críticos da sua empresa, com
                  tecnologia de deduplicação avançada, criptografia AES-256 e
                  armazenamento distribuído em múltiplos datacenters. Nossa
                  solução garante que seus dados estejam sempre protegidos
                  contra falhas de hardware, ataques de ransomware, erros
                  humanos e desastres naturais.
                </p>
                <br />
                <p className="sd-content">
                  Com backup incremental contínuo, versionamento ilimitado e
                  compressão inteligente, otimizamos o uso de banda e
                  armazenamento mantendo histórico completo dos seus arquivos.
                  Nossa tecnologia de backup híbrido combina velocidade local
                  com segurança da nuvem, permitindo restauração instantânea de
                  arquivos individuais ou recuperação completa de sistemas em
                  minutos.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Diferenciais exclusivos Somar:</strong> Backup de
                  endpoints, servidores e aplicações em uma única plataforma,
                  detecção automática de ransomware com isolamento de backups
                  infectados, restauração granular com preview de arquivos,
                  agendamento flexível personalizado, e dashboard centralizado
                  com alertas proativos. Nunca mais perca dados importantes com
                  nossa proteção de nível enterprise.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Implementação de Backup</h2>
                <p className="sd-content">
                  Nossa metodologia garante proteção imediata com configuração
                  otimizada para diferentes tipos de dados e aplicações
                  críticas.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Análise de Dados</h3>
                  <p className="xb-item--contact">
                    Mapeamento de dados críticos e definição de políticas de
                    backup.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Configuração Inteligente</h3>
                  <p className="xb-item--contact">
                    Setup automatizado com agendamento personalizado por tipo de
                    dado.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Backup Inicial</h3>
                  <p className="xb-item--contact">
                    Primeira sincronização completa com validação de
                    integridade.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Monitoramento Ativo</h3>
                  <p className="xb-item--contact">
                    Supervisão contínua com alertas e testes de restauração.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Vantagens do Backup Cloud</h2>
                  <p className="sd-content">
                    Proteja todos os dados da sua empresa com backup
                    automatizado e inteligente, garantindo recuperação rápida e
                    confiável em qualquer situação.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Backup automático de endpoints e servidores
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Criptografia AES-256 e deduplicação avançada
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Versionamento ilimitado de arquivos
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Detecção automática de ransomware
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Restauração granular com preview
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Armazenamento distribuído multi-datacenter
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Dashboard centralizado com alertas
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Compliance total com LGPD
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default BackupCloudPage;
